import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import SprayDataForm from './SprayDataForm';

const CreateSprayDataModal = ({ monitoringBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <Button
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faPlus} /> Add Spray Data
      </Button>
      <Modal backdrop='static' size='md' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            Create Spray Data for <b>{monitoringBlock.block_id}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: monitoringBlock.id,
              date: '',
              product_name: '',
              type: 'insecticide',
              efficacy_days: 14
            }}
            validate={(values) => {
              const errors = {};
              if (!values.date) errors.date = 'Required';
              if (!values.product_name) errors.product_name = 'Required';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.createSprayData({
                  block_id: values.block_id,
                  date: values.date,
                  product_name: values.product_name,
                  type: values.type,
                  efficacy_days: values.efficacy_days
                });
                successToast('Spray Data created successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to create spray data.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <SprayDataForm onCancel={hide} />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(CreateSprayDataModal);

